import Image from "next/image";

import cn from "classnames";

import { Text } from "@/components/text/text.component";

import type { CompareCompetitorTableAppearance } from "@/sanity/defaults/compareCompetitorTable.defaults";

import { dataColumnTextClass } from "./compareCompetitorTable.tableUtils";
import type { SanityCompetitorCompareColumn } from "./compareCompetitorTable.type";

const FALLBACK_LOGO_WIDTH = 102;
const FALLBACK_LOGO_HEIGHT = 48;

export const CompareCompetitorTableColumnHeader = ({
  column,
  columnIndex,
  highlightIndex,
  appearance,
}: CompareCompetitorTableColumnHeaderProps) => {
  if (!column) return null;

  const title = column.title ?? "";

  if (column.logoUrl) {
    const width =
      column.logoWidth && column.logoWidth > 0
        ? Math.round(column.logoWidth)
        : FALLBACK_LOGO_WIDTH;
    const height =
      column.logoHeight && column.logoHeight > 0
        ? Math.round(column.logoHeight)
        : FALLBACK_LOGO_HEIGHT;

    return (
      <div className="flex w-full items-center justify-center">
        <Image
          src={column.logoUrl}
          alt={column.logoAlt?.trim() || title}
          width={width}
          height={height}
          sizes="102px"
          className="h-auto max-h-12 w-auto max-w-25.5 shrink-0 object-contain"
        />
      </div>
    );
  }

  return (
    <Text
      variant="subtitle1"
      component="span"
      className={cn(
        "wrap-break-words block w-full min-w-0 text-center",
        dataColumnTextClass(columnIndex, highlightIndex, appearance),
      )}>
      {title}
    </Text>
  );
};

type CompareCompetitorTableColumnHeaderProps = {
  column: SanityCompetitorCompareColumn | null | undefined;
  columnIndex: number;
  highlightIndex: number;
  appearance: CompareCompetitorTableAppearance;
};
